module.exports = __webpack_public_path__ + "../resources/img/ic_flashlight_on_default.fd68ad71.svg";